import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function CollectionCredit(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cashier, setCashier] = useState({ username: '' });
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setCashier({
        ...cashier,
        username: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
    const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
    const url = `${baseUrl}all-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=${cashier.username}&mode=creditpay&status=2`;

    try {
      const response = await axios.get(url);
      const data = response.data;

      const formattedData = await Promise.all(data.map(async item => {
        const minidArray = item.min_id ? item.min_id.split(',') : [];
        const itestidArray = item.itest_id ? item.itest_id.split(',') : [];

        const minidRequests = minidArray.map(id => axios.get(`${baseUrl}edit-minor-comp/${id}`));
        const itestidRequests = itestidArray.map(id => axios.get(`${baseUrl}edit-components/${id}`));

        const [minidResponses, itestidResponses] = await Promise.all([
          Promise.all(minidRequests),
          Promise.all(itestidRequests)
        ]);

        const minData = minidResponses.map(response => response.data.cat.cat);
        const invData = itestidResponses.map(response => response.data.cat);

        let audiology = 0;
        let dental = 0;
        let dialysis = 0;
        let minor = 0;
        let ct = 0;
        let xray = 0;
        let scan = 0;

        if (minData.includes('Audiology')) {
          audiology = item.min_balance || 0;
        } else if (minData.includes('Dental')) {
          dental = item.min_balance || 0;
        } else if (minData.includes('Dialysis')) {
          dialysis = item.min_balance || 0;
        } else {
          minor = item.min_balance || 0;
        }

        if (invData.includes('CT')) {
          ct = item.inv_balance || 0;
        } else if (invData.includes('Xray')) {
          xray = item.inv_balance || 0;
        } else if (invData.includes('USG')) {
          scan = item.inv_balance || 0;
        }

        let invoiceLink = '';
        if (item.invoice) {
          invoiceLink = `/op-invoice/${item.invoice}`;
        } else if (item.lab_invoice) {
          invoiceLink = `/lab-invoice-op/${item.lab_invoice}`;
        } else if (item.inv_invoice) {
          invoiceLink = `/inv-invoice-op/${item.inv_invoice}`;
        } else if (item.min_invoice) {
          invoiceLink = `/min-invoice-op/${item.min_invoice}`;
        }

        return {
          ...item,
          fee: item.paid || 0,
          lab: item.lab_balance || 0,
          ct,
          xray,
          scan,
          dialysis,
          audiology,
          dental,
          minor,
          mode: item.mode || item.lab_pmode || item.inv_pmode || item.min_pmode || '',
          invoice: item.invoice || item.lab_invoice || item.inv_invoice || item.min_invoice || '',
          invoiceLink,
          minData,
          invData
        };
      }));

      setCombinedData(formattedData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [startDate, endDate, cashier.username]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const today = new Date();

  // Columns configuration for the DataGrid
  const columnsInvoiced = [
    { field: 'add_date_date', headerName: 'Date', width: 100 },
    { field: 'appt_id', headerName: 'Appointment ID', width: 120 },
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 80 },
    { field: 'pat__patient', headerName: 'Patient Name', width: 150 },
    { field: 'cons__consultant', headerName: 'Consultant', width: 200 },
    {
      field: 'invoice',
      headerName: 'Invoice No',
      renderCell: (params) => (
        <Link to={params.row.invoiceLink} target="_blank">
          {params.row.invoice}
        </Link>
      ),
      width: 140
    },
    { field: 'fee', headerName: 'Consulting', width: 80 },
    { field: 'lab', headerName: 'Lab', width: 80 },
    { field: 'ct', headerName: 'CT', width: 80 },
    { field: 'xray', headerName: 'Xray', width: 80 },
    { field: 'scan', headerName: 'Scan', width: 80 },
    { field: 'dialysis', headerName: 'Dialysis', width: 80 },
    { field: 'audiology', headerName: 'audiology', width: 80 },
    { field: 'dental', headerName: 'Dental', width: 80 },
    { field: 'minor', headerName: 'Minor', width: 80 },
    { field: 'mode', headerName: 'Mode', width: 80 },
    { field: 'cashier', headerName: 'Cashier', width: 100 },
  ];

  // Function to get row id for DataGrid
  const getRowId = (row) => row.appt_id;

  const FooterInvoiced = ({ rows }) => {
  let totalFee = 0;
  let totalLab = 0;
  let totalCt = 0;
  let totalXray = 0;
  let totalScan = 0;
  let totalDialysis = 0;
  let totalaudiology = 0;
  let totalDental = 0;
  let totalMinor = 0;

  rows.forEach((row) => {
    totalFee += Number(row.fee) || 0;
    totalLab += Number(row.lab) || 0;
    totalCt += Number(row.ct) || 0;
    totalXray += Number(row.xray) || 0;
    totalScan += Number(row.scan) || 0;
    totalDialysis += Number(row.dialysis) || 0;
    totalaudiology += Number(row.audiology) || 0;
    totalDental += Number(row.dental) || 0;
    totalMinor += Number(row.minor) || 0;
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
      <div>Total Consulting: {totalFee}</div>
      <div>Total Lab: {totalLab}</div>
      <div>Total CT: {totalCt}</div>
      <div>Total Xray: {totalXray}</div>
      <div>Total Scan: {totalScan}</div>
      <div>Total Dialysis: {totalDialysis}</div>
      <div>Total audiology: {totalaudiology}</div>
      <div>Total Dental: {totalDental}</div>
      <div>Total Minor: {totalMinor}</div>
    </div>
  );
};

  return (
    <section className="container mt-4">
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Credit Pay Collection Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="mb-4 mt-4">
              <label htmlFor="user" className="form-label">Search by Cashier</label>
              <select name="user" id="username" value={cashier.user} className="form-control"
                            onChange={(event) => handleUser(event)}>
                            <option value="">Select Cashier</option>
              {userData.map((User,index) => (
                <option key={index} value={User.username}>{User.username}</option>
              ))}
            </select>
            </div>
            </div>
        </div>
      </div>
    {!isLoading && combinedData.length > 0 ? (
                    <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                getRowId={getRowId}
                rows={combinedData.filter(payment => (payment.mode == 'creditpay' || payment.lab_pmode == 'creditpay' || payment.inv_pmode == 'creditpay' || payment.min_pmode == 'creditpay'))}
                columns={columnsInvoiced}
                pageSize={1000}
                slots={{
                  toolbar: GridToolbar,

                }}
                autoHeight
              />
            <table className="mt-4" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tfoot>
              <FooterInvoiced rows={combinedData.filter(payment => (payment.paid > 0 || payment.lab_balance > 0 || payment.inv_balance > 0 || payment.min_balance > 0))} />
            </tfoot>
          </table>

            </div>
        ) : (
        <></>
      )}
    </section>
  )
}

export default CollectionCredit;
